import classNames from 'classnames';
import styles from './EmbeddedForm.module.scss';
import { Heading, Picture, Container, Grid, GridCell } from 'ui/components';
import Script from 'next/script';
import { useContext } from 'react';
import { SiteContext } from 'application/adapters/context/SiteContext';

export interface EmbeddedFormProps {
    formHtmlCode: string;
	className?: string;
    heading?: string;
    image?: Umbraco.Image;
    styleFlip?: boolean; 
    imageGridSize?: Umbraco.GridCellWidths;
    sectionWidth?: Umbraco.SectionWidth;
}

export const EmbeddedForm: React.FC<EmbeddedFormProps> = ({ 
    formHtmlCode, 
    className,
    heading, 
    image, 
    styleFlip,
    imageGridSize,
    sectionWidth,
 }) => {

    const getContentWidth = (imageWidth: string): Umbraco.GridCellWidths => {
        const imageWidthNum = parseInt(imageWidth);
        const contentWidthNum = 100 - imageWidthNum;
        
        // Map to closest valid grid width
        if (contentWidthNum >= 100) return '';
        if (contentWidthNum >= 75) return '75';
        if (contentWidthNum >= 66) return '66';
        if (contentWidthNum >= 50) return '50';
        if (contentWidthNum >= 33) return '33';
        if (contentWidthNum >= 25) return '25';
        return '50'; // fallback
    };

    const imageWidth = imageGridSize || '50';
    const contentWidth = getContentWidth(imageWidth);

    const siteContext = useContext(SiteContext);
    const orttoTrackingKey = siteContext.getSettings('siteOrttoTrackingScript')?.scriptReference?.properties?.orttoTrackingKey;

    return (
        <section
			className={classNames(
				styles.EmbeddedForm,
				{ [styles.EmbeddedForm___flip]: styleFlip },
				className,
			)}
		>
            {formHtmlCode ? (
                <Container width={sectionWidth || 'Standard'} className={styles.EmbeddedForm_container}>
                    <Script strategy="afterInteractive" id="ortto">
                        {`
                            {window.ap3c = window.ap3c || {};
                            var ap3c = window.ap3c;
                            ap3c.cmd = ap3c.cmd || [];
                            ap3c.cmd.push(function() {
                                ap3c.init('${orttoTrackingKey}', 'https://capture-api-eu.ortto.app/');
                                ap3c.track({v: 0});
                            });
                            ap3c.activity = function(act) { ap3c.act = (ap3c.act || []); ap3c.act.push(act); };
                            var s, t; s = document.createElement('script'); s.type = 'text/javascript'; s.src = "https://cdneu.net/app.js";
                            t = document.getElementsByTagName('script')[0]; t.parentNode.insertBefore(s, t);}
                        `}
                    </Script>
                    {image ? (
                        <Grid wrap className={styles.EmbeddedForm_grid}>
                            <GridCell desktopWidth={contentWidth} className={styles.EmbeddedForm_contentWrapper}>
                                {heading && ( 
                                    <Heading className={styles.EmbeddedForm_heading} headingLevel={'h3'}>{heading}</Heading>
                                )}
                                <div className={classNames(styles.EmbeddedForm_Form, className)}>
                                    <div dangerouslySetInnerHTML={{ __html: formHtmlCode }} />
                                </div>
                            </GridCell>
                            <GridCell desktopWidth={imageWidth} className={styles.EmbeddedForm_imageWrapper}>
                                <span className={styles.EmbeddedForm_mediabox}>
                                    <Picture
                                        relativeUrl={image?.relativeUrl}
                                        properties={image.properties}
                                        focalPoint={image.focalPoint}
                                        aspectRatio={0.79}
                                        sizes="(min-width: 960px) 50vw, 100vw"
                                    />
                                </span>
                            </GridCell>
                        </Grid>
                    ) : (
                        <Grid className={styles.EmbeddedForm_grid}>
                            <GridCell desktopWidth="100" className={styles.EmbeddedForm_contentWrapper}>
                                <Heading className={styles.EmbeddedForm_heading} headingLevel={'h3'}>{heading}</Heading>
                                {formHtmlCode && (
                                    <div className={classNames(styles.embeddedForm, className)}>
                                        <div dangerouslySetInnerHTML={{ __html: formHtmlCode }} />
                                    </div>
                                )}
                            </GridCell>
                        </Grid>
                    )}
                </Container>
            ) : null }


        </section>
    );
};

